import { httpsCallable } from "firebase/functions";
import { signInAnonymously } from "firebase/auth";
import { aiFunctions, aiAuth } from "../firebase";

export async function callAiChat(payload) {
  if (!aiFunctions || !aiAuth) {
    throw new Error(
      "AI functions app is not configured. Please set REACT_APP_FIREBASE_QEMPLATE_* env vars."
    );
  }
  if (!aiAuth.currentUser) {
    await signInAnonymously(aiAuth);
  }
  const fn = httpsCallable(aiFunctions, "ai_chat", {
    timeout: 600000 // 10 minutes timeout (600,000 ms)
  });
  const res = await fn(payload);
  return res.data;
}
